// The network pill in the entrance's site header (app/art/welcome/PLAN.md
// section 4.0; docs/08-app-design.md section 3): the network this session
// talks to, then what this device holds. It takes Explore Vault's slot on
// entrance routes, so Devnet, Local or a custom RPC host is never below the
// fold. Plain text, no role=status: nothing is announced when it renders.
// The state word waits for the session, and phones show only the network.
// While the session starts, its settings are still the built-in defaults
// (session.ts), so the pill keeps its box and dot but names no network:
// a Devnet, Local or custom-RPC device never flashes "Mainnet" first.
// While this page load is saving a setup (savedSetup.ts 'saving'), or a
// setup it saved is stored but the session could not read it back (R67's
// double fault; 'unread'), the session reports an empty device: the pill
// then says "Saving setup" or "Setup saved", never "No vault here", so it
// agrees with the screen beside it.

import { networkLabel } from '../network';
import { useSavedSetup } from '../savedSetup';
import { type SessionState, useSession } from '../session';

const STATE_WORD: Record<SessionState, string | null> = {
  starting: null,
  'no-vault': 'No vault here',
  locked: 'Locked',
  unlocked: 'Unlocked',
  // The APP_DB_VERSION fence (docs/18 section 3, writer step 6): the database is at a later build's version.
  'newer-build': 'Newer version',
};

export function NetworkPill() {
  const { state, settings } = useSession();
  const saved = useSavedSetup();
  const word = saved === 'saving' ? 'Saving setup' : saved === 'unread' ? 'Setup saved' : STATE_WORD[state];
  if (state === 'starting') {
    return (
      <span className="net net-starting">
        <i aria-hidden="true" />
      </span>
    );
  }
  const label = networkLabel(settings.rpcUrl);
  return (
    <span className="net">
      <i aria-hidden="true" />
      <b title={label}>{label}</b>
      {/* the spaces keep the words apart for assistive technology; a flex box does not render them */}
      {word ? (
        <span className="net-word">
          {' '}
          <span aria-hidden="true">·</span> <span>{word}</span>
        </span>
      ) : null}
    </span>
  );
}
